<template>
  <v-carousel-item class="carousel-item">
    <div class="slide">
      <div class="slide-title">{{slide.title}}</div>
      <div class="slide-body">
        <div class = "slide-img" v-if="slide.image" :style="{'background-image': `url('${slide.image}')`}">
        </div>
        <div class="slide-content">
          <div class="slide-text" v-if="slide.text">
            <h3 v-if="slide.subtitle" class="slide-subtitle" v-html="slide.subtitle"></h3>
            <span v-if="slide.text" v-html="slide.text"></span>
          </div>
          <div class="slide-warning" v-if="slide.warning">
            <v-icon class="slide-warning-icon">mdi-alert</v-icon>
            <div v-html="slide.warning"></div>
          </div>
        </div>
      </div>
      <div v-intersect="onIntersect"></div>
      <div class="slide-actions" v-if="slide.details">
        <v-btn block color="#990000" dark @click="slide.showDetails = true"><v-icon left>mdi-information-outline</v-icon>{{ this.buttons.details }}</v-btn>
      </div>
    </div>
    <v-dialog v-model="slide.showDetails" fullscreen scrollable v-if="slide.details">
      <v-card>
        <v-card-title v-html="slide.subtitle || slide.title" class="slide-title"></v-card-title>
        <v-card-text v-html="slide.details"></v-card-text>
        <v-card-actions><v-spacer></v-spacer><v-btn block color="#990000" dark @click="slide.showDetails = false">{{ this.buttons.close }}</v-btn></v-card-actions>
      </v-card>
    </v-dialog>     
    <div
      class="scroll-arrow"
      v-show="!isIntersecting">
      <v-icon
        color="#990000"
        size="50"
      >
        mdi-arrow-down-bold
      </v-icon>
    </div>
  </v-carousel-item>
</template>

<script>

  export default {
    name: "ibSlide",
    props: {
      slide: {
        type: Object,
        required: true
      },
      index: {
        type: Number,
        required: true
      }
    },
    data() {
      return {
        buttons: {
          details: "",
          close: "",
        },
        isIntersecting: false,
      }
    },
    methods: {
      onIntersect (entries, observer) {
        this.isIntersecting = entries[0].isIntersecting
      },
    },
    mounted() {
      let params = new URLSearchParams(document.location.search)
        if (params.get("lang") === "spanish"){
          this.buttons = {
            details: "Más información",
            close: "Toque para cerrar"
          }
        } else {
          this.buttons = {
            details: "Tap to Learn More",
            close: "Tap to Close"
          }
      }
    }
  }

</script>

<style>

  .slide {
    height: 99vh;
    width: 100vw;
    max-height: 99vh;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    padding: 10px;
    overflow-y: scroll;
  }

  .slide-title {
    font-size: 1.5rem !important;
    font-weight: bold !important;
    flex-grow: 0;
    flex-shrink: 0;
    align-self: start;
    line-height: 1.7rem !important;
    padding-bottom: 10px !important;
    margin-bottom: 20px !important;
    width: 100%;
    color: #990000;
    word-break: break-word !important;
    font-variant:small-caps;    
    border-bottom: solid 2px #990000;
  }

  .slide-body {
    display: flex;
    flex-direction: column;
    flex-grow: 1;
    flex-shrink: 0;
  }

  .slide-img {
    flex-grow: 1;
    flex-shrink: 0;
    flex-basis: 30%;
    min-height: 30%;
    max-height: 50%; 
    background-position: center;
    background-repeat: no-repeat;
    background-size: contain;
    
  }

  .slide-content {
    display: flex;
    flex-direction: column;
    flex-grow: 1;
    flex-shrink: 1;
  }

  .slide-subtitle {
    line-height: 1.5rem;
    padding-bottom: 10px;
  }

  .slide-text{
    flex-grow: 1;
    flex-shrink: 0;
    line-height: 1.8rem;
  }

  .slide-warning-icon {
    font-size: 2rem !important;
    color: orange !important;
    padding-right: 0.5rem;
    align-self: start;
  }

  .slide-warning {
    flex-grow: 0;
    padding-bottom: 5px;
    line-height: 1.4rem;
    /* text-indent: -2rem; */
    display: flex;
  }

  .slide-actions {
    flex-grow: 0;
  }

  @media all and (orientation:landscape) {
    .slide-body {
      flex-direction: row;
    }
    .slide-img {
      max-height: 100%; 
    }
  }

  @media screen and (min-width: 768px) {
    .slide {
      height: 384px;
      width: 768px;
    }
  }

  .scroll-arrow {
    position: fixed;
    bottom: 10px;
    left: 5px;
    z-index: 999;
    pointer-events: none;
    border-radius: 50%;
    background-color: white;
    border: 2px solid #990000;
    opacity: 80%;
  }




</style>